import { Box, Container, useMediaQuery, useTheme } from "@material-ui/core";
import { useRouteMatch } from "react-router-dom";

import Header from "src/views/layout/Header";
import Menu from "src/views/layout/Menu";
import Footer from "src/views/layout/Footer";

export default function Layout(props) {
  const match = useRouteMatch();
  const theme = useTheme();
  const hideMenu = useMediaQuery(theme.breakpoints.down("sm"));
  
  return (
    <div className="main-content">
      <Header />
      <Container style={{ padding: 0, maxWidth: "100%" }}>
        <Box className="layout">
          {!hideMenu && (
            <Menu url={match.url} />
          )}
          <div className="content">
            {props.children}
            <Footer />
          </div>
        </Box>
      </Container>
    </div>
  );
}
